import { GridJsonData } from '../../models/element-types';
import { DomUtils } from '../../utils/dom-utils';

export interface GridRenderOptions {
    empty?: boolean;
    idsBlackList?: string[];
}

export abstract class BaseGridRenderer<TGridData extends GridJsonData = GridJsonData> {
    public render(data: TGridData, options?: GridRenderOptions): HTMLElement {
        return this.renderElement(data, options);
    }

    public createNew(options?: GridRenderOptions): HTMLElement {
        const data = { ...this.defaultData };
        data.id = DomUtils.generateUniqueElementId(options?.idsBlackList ?? []);
        return this.render(data, options);
    }

    protected abstract get defaultData(): TGridData;
    protected abstract renderElement(data: TGridData, options?: GridRenderOptions): HTMLElement;
}
